import React, { Component } from 'react';
import { withRouter } from 'react-router';

import FeedbackReportDisplay from './reportDisplay';
import CustomSurveyNameList from './customSurveysNameList';

class FeedbackReports extends Component {
  constructor() {
    super();
    this.state = {
      customSurveyId: null,
      businessId: null,
    };
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props;
    const { customSurveyId, businessId } = params;
    this.setState({ customSurveyId, businessId });
  }

  componentDidUpdate(prevProps) {
    const { customSurveyId } = this.props.match.params;
    const { customSurveyId: prevCustomSurveyId } = prevProps.match.params;

    if (customSurveyId !== prevCustomSurveyId) {
      this.setState({ customSurveyId });
    }
  }

  render() {
    const { customSurveyId, businessId } = this.state;
    return (
      <div className="row">
        <div className="col-md-3">
          <CustomSurveyNameList />
        </div>
        <div className="col-md-9">
          <FeedbackReportDisplay
            key={customSurveyId}
            customSurveyId={customSurveyId}
            businessId={businessId}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(FeedbackReports);



// WEBPACK FOOTER //
// ./src/components/feedbackReport/feedbackReports.js